import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppSettingsState } from './app-settings.state';

export const selectAppSettingsState = createFeatureSelector<AppSettingsState>('adminAppSettings');

export const selectAllSettings = createSelector(
  selectAppSettingsState,
  (state) => state.settings,
);

export const selectAppSettingsLoading = createSelector(
  selectAppSettingsState,
  (state) => state.loading,
);

export const selectAppSettingsError = createSelector(
  selectAppSettingsState,
  (state) => state.error,
);
